export const siteSettings = {
  name: "Tangem",
  link: "https://tangempro.live",
  email: "support@tangempro.live",
  appLink: "https://app.tangempro.live",
};
